import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-061f3d9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-receipt-wrap" }

import AppHeader from '@/components/Header.vue'
import { ref } from 'vue'
import { areaList } from '@vant/area-data'
import type { AddressEditInfo } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { AddressEdit } from 'vant'
import NextButton from '@/components/CommonFooterNextButton.vue'
import {
  NameReissueAddressInfoStorage,
  NameReissueModifyAddressInfoStorage,
} from '@/storage/nameplate-reissue'

export default /*#__PURE__*/_defineComponent({
  __name: 'edit-receipt-info',
  setup(__props) {

const $router = useRouter()

const $route = useRoute()

const defaultAddressInfo = ref<AddressEditInfo>({
  tel: '',
  name: '',
  city: '',
  county: '',
  country: '',
  province: '',
  areaCode: '',
  addressDetail: '',
})
if ($route.query.isModify) {
  defaultAddressInfo.value = NameReissueModifyAddressInfoStorage.get()
} else {
  const storageData = NameReissueAddressInfoStorage.get()
  if (storageData) {
    defaultAddressInfo.value = NameReissueAddressInfoStorage.get()
  }
}
function onSave(data: AddressEditInfo) {
  console.log('data', data)
  if ($route.query.isModify) {
    NameReissueModifyAddressInfoStorage.set(data)
  } else {
    NameReissueAddressInfoStorage.set(data)
  }
  $router.go(-1)
}
function nextHandle() {
  ;(document.querySelector('.fault-address-box .van-address-edit__button') as HTMLElement).click()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "编辑收件信息" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(AddressEdit), {
        class: "fault-address-box",
        "area-list": _unref(areaList),
        "address-info": defaultAddressInfo.value,
        "save-button-text": "保存并使用",
        onSave: onSave
      }, null, 8, ["area-list", "address-info"])
    ]),
    _createVNode(NextButton, {
      title: "提交",
      onClick: nextHandle
    })
  ], 64))
}
}

})